import { Component } from "@angular/core";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { OverauthorizedComponent } from "@ponder-shared/components/overauthorized.component";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";

@Component({
    imports: [OverauthorizedComponent],
    templateUrl: "./signup-confirmation.component.html"
})
export class SignUpConfirmationComponent {
    public readonly envelopeIconSvg = SvgIconMap.get(SvgIcon.EnvelopeClosed)!;

    public constructor(private events: EventBroker) {

    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();
    }
}